import {makeStyle} from '../../utils';
import { blackHigh, blackOutline, h5, horiCenterAbs, overline, subTitle2, button, rowCenter } from '../../resources/styles';
import view from '../../Enums';

const styles = {};

styles['card'] = makeStyle({
    display:'flex',margin:'0px 42px',padding:"16px 0px",borderBottom:`1px solid ${blackOutline.color}`
    })

var titleFontStyle = {
    ...overline,
    fontStyle: "normal",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    color: "rgba(0, 0, 0, 0.5)"
}

styles['title'] = makeStyle({...titleFontStyle,width:'40%',paddingTop:'4.5px'});

const valueFontStyle = {
    ...subTitle2,
    fontStyle: "normal",
    color: "#212121"
}

styles['value'] = makeStyle({...valueFontStyle})

styles['card_container'] = makeStyle({
    maxWidth:'770px',
    width:'100%',
    border:`1px solid ${blackOutline.color}`,
    borderRadius: '6px', boxSizing: 'border-box'
},{marginTop:48} );

styles['header'] = makeStyle([rowCenter, { padding: '0 20px', borderBottom: `1px solid ${blackOutline.color}`, alignSelf: 'stretch' }], null, { display: 'none' }, view.TAB);

styles['back_icon'] = makeStyle({width:'20px',height:'20px',...blackHigh});

styles['header_title'] = makeStyle({marginLeft:'18px',...h5, letterSpacing: '-0.28px', padding: '29px 0'});

styles['signout_ripple'] = makeStyle({
    marginTop: 16,
    borderRadius: 6,
    color: 'var(--theme-color)',
    marginBottom:100
});

styles['signout_button'] = makeStyle({
    width: 232,
    borderRadius: 6,
    padding: '8px 0',
    cursor: 'pointer',
    border: '1px solid var(--theme-color)',
    ...button,
    textAlign: 'center',
});

styles['footer'] = makeStyle({ width: '100%', zIndex: 100 });

export default styles